import Main from './ComplaintMain'
import Show from './ComplaintShow'
import Config from './ComplaintConfig'
import CategoryEdit from './ComplaintCategoryEdit'

export default {
  CategoryEdit,
  Config,
  Main,
  Show,
}
